import { useRedeemPointsLink } from "@/hooks/useRedeemPointsLink";
import { ClockIcon, ThumbUpIcon } from "@roman/shared/components/Icons";
import { differenceInDays, differenceInHours, differenceInMinutes, differenceInSeconds } from "date-fns";
import { useEffect, useState } from "react";
import { RedeemOption, type RedeemOptionProps } from "./components/RedeemOption";

export const RedeemPointsPage = () => {
  const { onClick } = useRedeemPointsLink({ spram1: "pointpage" });
  const DEADLINE = new Date("2025-05-30T00:00:00");
  const COUNTDOWN_START_DAYS = 9;

  const [deadline, setDeadline] = useState<Date | null>(() => {
    const now = new Date();
    return now < DEADLINE ? DEADLINE : null;
  });

  const [countdown, setCountdown] = useState<string>("2025-5-30 (金) am12:00");

  useEffect(() => {
    if (!deadline) return;

    const updateCountdown = () => {
      const now = new Date();
      const timeDifference = deadline.getTime() - now.getTime();

      if (timeDifference <= 0) {
        setCountdown("2025-5-30 (金) am12:00");
        setDeadline(null);
        return;
      }

      const daysDifference = differenceInDays(deadline, now);
      if (daysDifference > COUNTDOWN_START_DAYS) {
        setCountdown("2025-5-30 (金) am12:00");
        return;
      }

      const days = differenceInDays(deadline, now);
      const hours = differenceInHours(deadline, now) % 24;
      const minutes = differenceInMinutes(deadline, now) % 60;
      const seconds = differenceInSeconds(deadline, now) % 60;

      setCountdown(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    };

    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [deadline]);

  const REDEEM_OPTION: RedeemOptionProps[] = [
    {
      icon: "/assets/redeem-tasks.svg",
      title: "条件クリアで大量ポイントを獲得",
      buttonText: "最大10万ポイント以上GET",
      onClick,
      isDisplayLabel: true,
      labelContent: (
        <div className="rounded-full absolute top-[-10px] left-[-10px] flex h-[20px] px-3 py-0.75 justify-center items-center gap-0.5 bg-red">
          <ThumbUpIcon />
          <div className="text-white text-xs font-bold leading-none">おすすめ</div>
        </div>
      ),
    },
    {
      icon: "/assets/dalpa-soccer-school.svg",
      title: "サッカースクールの無料体験で、大量ポイントを獲得",
      buttonText: "50,000ポイントGET",
      onClick: () => window.open("https://half-pressure-b6c.notion.site/1f1941dfbe4080f3bc34e951eb5d17f5", "_blank"),
      isDisplayLabel: !!deadline,
      labelContent: (
        <div className="rounded-full absolute top-[-10px] left-[-10px] flex h-[20px] px-3 py-0.75 justify-center items-center gap-0.5 bg-[#01A4F9]">
          <ClockIcon />
          <div className="text-white text-xs font-bold leading-none">{countdown}</div>
        </div>
      ),
    },
    {
      icon: "/assets/redeem-videos.svg",
      title: "動画広告を見て、簡単にポイントを獲得",
      buttonText: "5ポイント以上からGET",
      disabled: true,
      onClick,
    },
    {
      icon: "/assets/redeem-crypto.svg",
      title: "1分で仮想通貨口座を開設し大量ポイントを獲得",
      buttonText: "8000ポイントGET",
      disabled: true,
      onClick,
    },
  ];

  return (
    <div className="w-full h-full p-8 bg-[#F5F5F5]">
      <div className="bg-[#E8F0FE] rounded-lg p-6 mb-6">
        <h2 className="text-lg font-bold mb-2">無料ポイント獲得のコンテンツ</h2>
        <p className="text-sm text-gray-600 mb-4">ちょっとしたスキマ時間で、ポイントがどんどん貯まる♪</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {REDEEM_OPTION.map((option, index) => (
            <RedeemOption key={index} {...option} />
          ))}
        </div>
      </div>
    </div>
  );
};
